import React from 'react';
import {ReactComponent as MainLogoImage} from '../Images/svg/logo.svg';

const MainLogo = () => {
    return <MainLogoImage />;
};

export default MainLogo;
